const notifee = {
  getInitialNotification: () => Promise.resolve(null),
  onForegroundEvent: () => () => {},
  onBackgroundEvent: () => {},
  createChannel: () => Promise.resolve(''),
  createChannelGroup: () => Promise.resolve(''),
  displayNotification: () => Promise.resolve(''),
  cancelNotification: () => Promise.resolve(),
  cancelAllNotifications: () => Promise.resolve(),
  getDisplayedNotifications: () => Promise.resolve([]),
  getBadgeCount: () => Promise.resolve(0),
  setBadgeCount: () => Promise.resolve(),
  incrementBadgeCount: () => Promise.resolve(),
  decrementBadgeCount: () => Promise.resolve(),
  requestPermission: () => Promise.resolve({ authorizationStatus: 1 }),
  getNotificationSettings: () => Promise.resolve({ authorizationStatus: 1 }),
};

export default notifee;

export const EventType = {
  UNKNOWN: -1,
  DISMISSED: 0,
  PRESS: 1,
  ACTION_PRESS: 2,
  DELIVERED: 3,
  APP_BLOCKED: 4,
  CHANNEL_BLOCKED: 5,
  CHANNEL_GROUP_BLOCKED: 6,
  TRIGGER_NOTIFICATION_CREATED: 7,
  FG_ALREADY_EXIST: 8,
};

export const AndroidImportance = {
  NONE: 0,
  MIN: 1,
  LOW: 2,
  DEFAULT: 3,
  HIGH: 4,
};

export const AuthorizationStatus = {
  NOT_DETERMINED: -1,
  DENIED: 0,
  AUTHORIZED: 1,
  PROVISIONAL: 2,
};
